import { queryData } from './index';
import { serializeExtension, serializeStore } from '../utils/serializers';
import * as R from 'ramda';
import { sortByExtNameAsc } from '../utils/stores';

export function* fetchStoresList() {
  const data = yield queryData({
    url: `/api/dial_plans?includes[]=inbounds`,
    method: 'get',
  });
  return data.dial_plans.map(serializeStore);
}

export function* fetchStore(id: number) {
  const data = yield queryData({
    url: `/api/dial_plans/${id}?includes=extensions`,
    method: 'get',
  });
  if (data.dial_plan.extensions) {
    return sortByExtNameAsc(
      data.dial_plan.extensions.map(serializeExtension).filter(R.propEq('active', true))
    );
  }
}
